// Declare gtag as a global function
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const GTAG_ID = 'G-FKVHEYPTM0';

export const initializeGtag = () => {
  // Create and add the first script tag
  const firstScript = document.createElement('script');
  firstScript.async = true;
  firstScript.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(firstScript);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Configure gtag
  window.gtag('js', new Date());
  window.gtag('config', GTAG_ID);
};